<template>
    <div class="word-select">
        <p
            v-for="(item,index) in newForm"
            :key="index"
            class="p-row"
            :class="{[item.type]: true}"
            @click="handleClick(item)"
        >
            <span v-if="item.type === 'h4'">
                文字局部<font style="font-size:22px;">大小</font>/<font color="red">颜色</font>修改
            </span>
            <span v-else v-html="item.name">{{item.name}}</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "word-select",
        data(){
            return {
                newForm: [
                    {type: 'h1', name: '添加标题'},
                    {type: 'h2', name: '添加副标题'},
                    {type: 'h3', name: '添加正文内容'},
                    {type: 'text', name: '文字局部<font style="font-size:22px;">大小</font>/<font color="red">颜色</font>修改'},
                    //{type: 'text_word', name: '富文本测试2'},
                ]
            }
        },
        methods: {
            handleClick(item){
                this.$emit('onWordSelect', item)
            }
        }
    }
</script>

<style lang="scss" scoped>
.word-select{
    display: flex;
    width: 100%;
    flex-direction: column;
    padding-top: 20px;

    .p-row{
        display: flex;
        height: 50px;
        line-height: 50px;
        margin: 0px 20px;
        justify-content: center;
        /*border-bottom: 1px solid #8C8A8B;*/
        color:rgba(51,51,51,1);
        cursor: pointer;
        user-select: none;

        &:hover{
            opacity: .8;
        }
        &:active{
            opacity: .5;
        }

        &.h1{
            font-size:30px;
            font-weight: 500;
        }
        &.h2{
            font-size:22px;
            font-weight: 400;
        }
        &.h3{
            font-size:14px;
            color:rgba(97,98,102,1);
            line-height: 48px;
            font-weight: 400;
        }
        &.h4{
            border-top: 1px solid #EBEEF5;
            font-size:12px;
            border-bottom: none;
        }
    }
}
</style>